import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import WveInputCheckbox from 'SharedComponents/WveInputs/WveInputCheckbox/WveInputCheckbox';
import WveStyleElementLabel from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElementLabel/WveStyleElementLabel';
import { toggleFitToScreen } from 'PreviewActions';
import { UI } from 'Reducers/ad/utils';

const Row = styled.div`
  display: flex;
  align-items: center;
  border: none;
  padding: 15px 0 0 10px;
`;

const ScaleIndicator = styled.div`
  padding: 0px 10px;
`;

// eslint-disable-next-line no-shadow
const FitToScreenToggle = ({ fitToScreen, toggleFitToScreen, scale }) => (
  <Row>
    <WveStyleElementLabel label="fit to screen" />
    <WveInputCheckbox
      id="fit-to-screen"
      value={fitToScreen}
      onChange={toggleFitToScreen}
      placeholder=""
      disabled={false}
      label=""
    />
    <ScaleIndicator>
      scale {(scale * 100).toFixed(0)}%
    </ScaleIndicator>
  </Row>
);

FitToScreenToggle.propTypes = {
  scale: PropTypes.number,
  fitToScreen: PropTypes.bool,
  toggleFitToScreen: PropTypes.func,
};

FitToScreenToggle.defaultProps = {
  scale: 1,
  fitToScreen: true,
  toggleFitToScreen: () => {},
};

const mapStateToProps = state => ({
  scale: state.getIn([UI, 'canvasScale']),
  fitToScreen: state.getIn([UI, 'fitToScreen']),
});

const mapDispatchToProps = dispatch => ({
  toggleFitToScreen: () =>
    dispatch(toggleFitToScreen()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FitToScreenToggle);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/FitToScreenToggle/FitToScreenToggle.jsx